import { styled } from "@mui/material/styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
const InputMain = styled("div")(({ theme }) => ({
  // marginBottom: "15px",
  paddingBottom: "20px",
  position: "relative",
  "& .inputMoreText": {
    position: "absolute",
    top: "57%",
    right: "0",
    paddingRight: "5px",
    transform: "translateY(-57%)",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    textAlign: "right",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    background: "transparent",
  },
  "& input.has_more_text": {
    paddingRight: "31px",
    fontFamily: theme.typography.fontFamily,
  },
  "& .no_label": {
    marginTop: "30px",
  },
}));

const CustomInput = styled("input")(({ theme, error }) => ({
  width: "100%",
  height: "48px",
  background: "#F2F2F2",
  borderRadius: "10px",
  border: `1px solid ${error ? theme.palette.error.main : "transparent"}`,
  fontFamily: theme.typography.fontFamily,
  padding: "10px",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "25px",
  color: error ? theme.palette.error.main : "rgba(11, 11, 11, 0.6)",
  "&:focus": {
    outline: "none",
    borderColor: theme.palette.primary.main,
  },
  "::placeholder": {
    color: "rgba(11, 11, 11, 0.6)",
  },
}));
const CustomLabel = styled("label")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "25px",
  color: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
}));

const ErrorSpan = styled("span")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  color: "red",
  fontWeight: 400,
  fontSize: "14px",
  position: "absolute",
  top: "81%",
  left: 0,
}));

const PasswordIcon = styled(({ visible, ...props }) =>
  visible ? <Visibility {...props} /> : <VisibilityOff {...props} />
)(({ theme }) => ({
  position: "absolute",
  top: "55%",
  right: "10px",
  transform: "translateY(-55%)",
  color: "#0B0B0B",
  cursor: "pointer",
  fontSize: "20px",
}));

export { InputMain, CustomInput, CustomLabel, ErrorSpan, PasswordIcon };
